import { ADD_PATH, EDIT_PATH, EMPTY_PATH, LIST_PATH } from "../../../../crossconcern/utilities/properties/path.property";
import { PRIVATE_PROMOTION_ADD_ROUTE, PRIVATE_PROMOTION_EDIT_ROUTE, PRIVATE_PROMOTION_LIST_ROUTE } from "../../../../crossconcern/utilities/properties/routename.property";
import { PromotionPrivateListComponent } from "./list";
import { PromotionEditComponent } from "./edit";
import { PromotionNewComponent } from "./new";
import { BackofficeGuardHelper } from "../../../../crossconcern/helpers/generic/backofficeguard.helper";
var ɵ0 = { routeName: PRIVATE_PROMOTION_LIST_ROUTE }, ɵ1 = { routeName: PRIVATE_PROMOTION_EDIT_ROUTE }, ɵ2 = { routeName: PRIVATE_PROMOTION_ADD_ROUTE };
export var PROMOTION_ROUTES = [
    {
        path: EMPTY_PATH,
        redirectTo: LIST_PATH,
        pathMatch: "full"
    },
    {
        path: LIST_PATH,
        component: PromotionPrivateListComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ0
    },
    {
        path: EDIT_PATH + "/:id",
        component: PromotionEditComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ1
    },
    {
        path: ADD_PATH,
        component: PromotionNewComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ2
    }
];
export { ɵ0, ɵ1, ɵ2 };
